import { render, staticRenderFns } from "./ImageAreaObjectDrawer.vue?vue&type=template&id=92aa2688&"
import script from "./ImageAreaObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./ImageAreaObjectDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports